export enum OncologyOptions {
  YES = 'Sim',
  NO = 'Não',
  NOT_INFORMED = 'Não informado'
}

export const oncologyOptions = [
  {
    label: 'Sim',
    value: OncologyOptions.YES,
    booleanValue: true
  },
  {
    label: 'Não',
    value: OncologyOptions.NO,
    booleanValue: false
  }
]
